module.exports = __webpack_public_path__ + "img/file.d0c30ec0.svg";